import NoOrgCell from 'src/components/NoOrgCell'

const NoOrgPage = () => {
  return <NoOrgCell />
}

export default NoOrgPage
